<template>
    <b-container class="legalPerson">
        <b-card class="mt-4 mb-4">
            <standard-table ref="table"
                            :items="items"
                            :fields="getFields()"
                            :theadTrClass="'first-2-table-cols'"

                            :row-before-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                            :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                            :row-after-search="{cols: 12, sm: 12, md: 12, lg: 4, xl: 4, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                            :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                            :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                            :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                            :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                            fullWidth="true"
                            noContainerPadding="true"
                            @rowEdit="pushToEdit"
                            @rowDelete="deleteItem">

                <b-container slot="row-before-search" class="mw-100 p-0">
                    <b-row align-h="end">
                        <b-col cols="auto">
                            <b-button v-on:click="pushToEdit()" class="mb-3 b-c-blue" id="add-legal-person">
                                {{$t('message.add')}}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-container>

                <b-container slot="row-after-per-page" class="mw-100 p-0">
                    <b-row>
                        <b-col>
                            <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="$refs.table.excel($tc('message.legalPerson', 2))">Excel</b-button>
                        </b-col>
                    </b-row>
                </b-container>
            </standard-table>
        </b-card>
    </b-container>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'LegalPerson',
    created () {
      this.fetchData()
    },
    updated () {
      this.$root.$emit('checkExcel')
    },
    data () {
      return {
        removedOptions: [],
        removedFilter: null,
        insuranceCompanyOptions: [],
        insuranceCompanyFilter: null,
        showCollapse: false,
        items: []
      }
    },
    methods: {
      fetchData () {
        this.$root.$emit('activeLoader', true)
        this.getLegalPerson()
      },
      getLegalPerson () {
        this.items = []
        Vue.myGet(this, '/persona_giuridica', 'persone').then((legalPersons) => {
          this.items = legalPersons
          this.$root.$emit('activeLoader', false)
        }).catch(error => {
          Vue.manageErrors(this, error)
        })
      },
      getFields () {
        return [
          { key: 'edit', label: '' },
          { key: 'delete', label: '' },
          { key: 'ragione_sociale', label: `${this.$tc('message.businessName', 1)}`, sortable: true, sortDirection: 'desc' },
          { key: 'codice_fiscale', label: `${this.$tc('message.taxCode', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
          { key: 'partita_iva', label: `${this.$tc('message.VATNumber', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
          { key: 'provincia', label: `${this.$tc('message.province', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
          { key: 'comune', label: `${this.$tc('message.common', 1)}`, sortable: true, sortDirection: 'desc' },
          { key: 'cap', label: `${this.$tc('message.cap', 1)}`, sortable: true, sortDirection: 'desc' },
          { key: 'indirizzo', label: `${this.$tc('message.address', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
          { key: 'telefono', label: `${this.$tc('message.phone', 1)}`, sortable: true, sortDirection: 'desc' },
          { key: 'email', label: `${this.$tc('message.email', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
          { key: 'email_secondaria', label: `${this.$tc('message.secondaryEmail', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
          { key: 'fax', label: `${this.$tc('message.fax', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
          { key: 'pec', label: `${this.$tc('message.pecMail', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true }
        ]
      },
      pushToEdit (event) {
        const item = event && event.item
        item && item.id ? this.$router.push({
          name: 'EditLegalPerson',
          params: { id: item.id }
        }) : this.$router.push({
          name: 'EditLegalPerson',
          params: { id: 'new' }
        })
      },
      deleteItem (event) {
        const item = event && event.item
        if (item && item.id) {
          this.$root.$emit('deleteItem', { description: item.ragione_sociale, path: `/persona_giuridica/${item.id}`, redirect: this.$route.path })
        }
      }
    }
  }
</script>
